<template>
	<div class="stocklist">
		<el-card>
			<div v-for="tab in tabs">
				<el-row>
					<el-col :span="24">
						<el-form :inline="true" label-width="90px" size="mini">
							<el-form-item label="商品编号">
								<el-input v-model="searchlist.p_pkval" type="text" style="width:120px">
								</el-input>
							</el-form-item>
							<el-form-item label="所在仓库">
								<el-select
									v-model="searchlist.batch"
									:clearable="true"
									:filterable="true"
									style="width:150px"
								>
									<el-option v-for="item in storehouselist" :key="item.title" :label="item.title" :value="item.title"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="货 架">
								<el-select
									v-model="searchlist.shelves"
									filterable
									remote
									reserve-keyword
									placeholder="可输入货架搜索"
									:remote-method="val => addrinput(val)"
									style="width:150px"
								>
									<el-option v-for="(opt, opti) in shelveslist" :key="opti" :value="opt.d_name">{{ opt.d_name }}</el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button size="mini" type="success" @click="refreshgrid(true)">查询</el-button>
								<el-button size="mini" @click.native="ResetFilterInfo()" type="warning">重置</el-button>
							</el-form-item>
							<el-form-item>
								<handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>
				<el-row style="height:10px;"></el-row>
				<el-row>
					<el-col :span="24">
						<tableui
							style="width:100%;"
							v-loading="loading"
							editcell="0"
							:tableData="orderlist"
							:columns="tab.columns"
							:gridheight="gridheight"
							@gridsort="gridsort"
							@checkboxchange="checkboxchange"
							@gridscroll="gridscroll"
						></tableui>
					</el-col>
				</el-row>
			</div>
			<div>
				<el-row>
					<el-col :span="12">
						<span>共 {{count}} 条数据</span>
				    </el-col>
				</el-row>
			</div>
		</el-card>
		<exportwin ref="exportwin"></exportwin>
	</div>
</template>
<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableui from '@/components/table/tablegrid.vue';
import Utils from '../../lib/util.js';
import exportwin from '@/components/order/exportwin.vue';
export default {
	components: {
		tableui,
		handlerbutton,
		exportwin
	},
	data() {
		return {
			searchlist: {
				id:'',
				batch:'',
				p_pkval:'',
				shelves:''
			},
			activeTabIndex: 0, //激活的选项卡index
			activeName:'',
			orderlist: [],
			gridheight: (window.innerHeight * 70) / 100 + 'px',
			loading: false,
			pageindex: 0,
			pagesize: 200,
			search: '',
			sort: ' d_createtime asc',
			tabs: [],
			mode: '商品预警', //当前操作的功能模块名称
			selectedall: false,
			checkedrow: [],
			count:0,
			shelveslist:[],
			divclass:'stocklist',
			storehouselist:[]
		}; 
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/stockmanager/stocklist.scss');
			this.getTabs();
		});
	},
	methods: {
		getstorehouselist(){
			var that = this;
			this.$apipost.get.GetDicByRole({type:'仓库'}).then(res => {
				if(res.list!=undefined)
					that.storehouselist=res.list;
			});
		},
		//获取选项卡
		getTabs() {
			this.$apipost.get.GetTabs({ parentid: 418 }).then(res => {
				this.tabs = res.tabs;
				this.activeName=res.tabs[0].type;
				this.GetTabData();
				this.getstorehouselist();
			});
		},
		//获取货架
		addrinput(val) {
			var that = this;
			if(val!=""){
				this.$apipost.get.dic({ type: '货架',value:val }).then(res => {
					if (res != '') {
						that.shelveslist = res.data.list;
					}
				});
			}
		},
		//清空筛选条件
		ClearSearch(type) {
			this.searchlist = {
				id:'',
				batch:'',
				p_pkval:'',
				shelves:''
			};
		},
		//获取表头方法
		GetTabData() {
			if (this.tabs[this.activeTabIndex].columns.length == 0) {
				this.GetColumns();
			} else {
				this.refreshgrid(true);
			}
		},
		//滚动加载列表
		gridscroll(e) {
			if(e!=undefined){
				var that = this;
				const scrollDistance = e.event.target.scrollHeight -e.e.scrollTop-e.event.target.offsetHeight;
				if (scrollDistance <=90) {
					that.refreshgrid(false);
				}
			}
		},
		buttonhandle(e) {
			if (e.event == 'export') {
				this.ExportList();
			}
		},
		//刷新列表
		refreshgrid(isrefresh) {
			//debugger
			var that = this;
			var isload = true;
			if (isrefresh) {
				this.orderlist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.selectedall=false;
			} else {
				//加载下一页
				if (parseInt(this.tabs[this.activeTabIndex].pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			
			var isgo=true;
			if(this.searchlist.batch==''&&this.searchlist.p_pkval==''&&this.searchlist.shelves==''){
				isgo=false;
				that.orderlist=[];
				that.count=0;
				that.tabs[that.activeTabIndex].pagecount=0;
			}
			
			if (isload&&isgo) {
				var paraminfo={
					search: this.GetSearchObj(),
					tab:this.tabs[this.activeTabIndex].type,
					pageindex: this.pageindex,
					pagesize: this.pagesize,
					sort: this.sort,
					showcol: JSON.stringify(this.tabs[this.activeTabIndex].columns),
					l_mode:this.mode,
					userid:localStorage.getItem('userid')
				}
				this.loading = true;
				this.$apipost.get
					.GetStockCargoWarning({
						paraminfo:paraminfo
					})
					.then(res => {
						that.loading = false;
						if (res.data.length > 0) {
							if (that.pageindex > 0) {
								that.orderlist=that.orderlist.concat(res.data);
							} else {
								that.orderlist = res.data;
							}
							this.count=res.count;
							that.tabs[this.activeTabIndex].pagecount = res.pagecount;
						}
						else{
							this.$tool.message('未查找到符合条件的商品信息', 2);
						}
					}).catch(e=>{
						that.refreshgrid(isrefresh);
					});
			}
		},
		//组合筛选条件
		GetSearchObj() {
			var search = JSON.parse(JSON.stringify(this.searchlist));
			return JSON.stringify(search);
		},
		//复选框勾选触发
		checkboxchange(e) {
			if (!e.selectedall) {
				this.checkedrow = e.rows; //勾选了的列表
			}
			this.selectedall = e.selectedall;
		},
		//获取列配置信息
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 1, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode }).then(res => {
				that.tabs[that.activeTabIndex].columns = res;
				that.refreshgrid(true);
			});
		},
		//列表排序
		gridsort(e) {
			//e.column.prop--排序列名
			//e.column.order--ascending/descending --排序方式 
			//console.log('排序', e);
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			this.refreshgrid(true);
		},
		//重置筛选
		ResetFilterInfo(){
			this.ClearSearch(1); //先清空筛选条件
			//this.refreshgrid(true);
		},
		//获取勾选数据组合json
		GetCheckedOrder(isempty) {
			var pkval = '';
			var isgo = true;
			var search = {
				id: ''
			};
			var searchinfo = '';
			if (!this.selectedall) {
				this.checkedrow.forEach(e => {
					pkval += e.id + ',';
				});
				if (pkval != '') {
					pkval = pkval.substring(0, pkval.length - 1);
					search.id = pkval; //这里的筛选条件对象的结构与订单筛选条件结构一致
					searchinfo = JSON.stringify(search);
				} else {
					if (!isempty) this.$tool.message('请勾选数据', 2);
				}
			} else {
				searchinfo = this.GetSearchObj();
			}
			return searchinfo;
		},
		//导出
		ExportList() {
			var that = this;
			var searchinfo = this.GetCheckedOrder(false);
			if (searchinfo != '') {
				if (that.$refs.exportwin != undefined) {
					that.$refs.exportwin.init({
						searchinfo: searchinfo,
						pageparam: that._data,
						handtype: 8
					});
				}
			}
		}
	}
};
</script>
